import {
  DTOCreateForgeParticipant,
  DTOCreateForgeParticipantResponse,
  DTODeleteForgeParticipantResponse,
  DTOUpdateForgeParticipant,
  DTOUpdateForgeParticipantResponse,
} from "../../dto";
import { RequestExecutor } from "../../transport";

export class ForgeParticipantsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(workspaceId: string, projectId: string) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/participants`,
      DTOUpdateForgeParticipantResponse,
      {
        method: "GET",
      }
    );
  }

  create(workspaceId: string, projectId: string, body: DTOCreateForgeParticipant) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/participants`,
      DTOCreateForgeParticipantResponse,
      {
        method: "POST",
        body,
      }
    );
  }

  update(workspaceId: string, projectId: string, id: string, body: DTOUpdateForgeParticipant) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/participants/${id}`,
      DTOCreateForgeParticipantResponse,
      {
        method: "PUT",
        body,
      }
    );
  }

  delete(workspaceId: string, projectId: string, id: string) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/participants/${id}`,
      DTODeleteForgeParticipantResponse,
      {
        method: "DELETE",
      }
    );
  }
}
